module.exports = __webpack_public_path__ + "static/media/photo-10-m.7ce0efe9.jpeg";